import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import App from "./components/App";
import ScrollToTop from "./helpers/ScrollToTop";
import { AuthContextProvider } from "./context/AuthContext";
import regularIcons from "./assets/icons/regularIcons";
import { ThemeProvider } from "./context/ThemeContext";

regularIcons();

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthContextProvider>
        <ThemeProvider>
          <ScrollToTop />
          <App />
        </ThemeProvider>
      </AuthContextProvider>
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </BrowserRouter>
  </React.StrictMode>
);
